import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const SupplierQuestionsTutorialModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=6Pt_oI6eZ8o&ab_channel=apadua" />
);

export default SupplierQuestionsTutorialModal;
